module.exports = __webpack_public_path__ + "img/chevron-right-icon.153ead56.svg";